<ng-template #unknownPhoneTemplate>
    <div class="flex flex-row items-start justify-between gap-8">
        <div>
            Podle telefonu jsme Vás nenašli, zkusíte se přihlásit emailem? Pokud by se přihlášení ani potom nezdařilo,
            vyplňte, prosím, znovu&#32;
            <a
                href="https://www.hyponamiru.cz/hypoteky/hypotecni-kalkulacka"
                target="_blank"
                class="calculator-link"
                [attr.data-testid]="'login-dialog-mortgage-calculator'">
                hypoteční kalkulačku.
            </a>
        </div>
        <button mat-icon-button (click)="snackBarRef.dismiss()" [attr.data-testid]="'login-dialog-unknown-phone'">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</ng-template>
<ng-template #unknownEmailTemplate>
    <div class="flex flex-row items-center justify-between gap-8">
        <div>Podle emailu jsme Vás nenašli, zkusíte se přihlásit telefonním číslem?</div>
        <button mat-icon-button (click)="snackBarRef.dismiss()" [attr.data-testid]="'login-dialog-unknown-email'">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</ng-template>

<div class="loading"><mat-spinner></mat-spinner></div>
@if (showPage) {
    <div class="login-wrap" [ngClass]="{ hide: usersService.authenticated() }">
        <div class="container" fxLayout="row" fxLayout.lt-md="column">
            <div class="left" fxFlex="100" fxLayoutAlign="center center">
                <span class="logo"><img src="../../../../../assets/logo.svg" /></span>
                <div class="infobox" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="space-between center">
                    <div class="text">
                        <h1>
                            Hypoteční
                            <br />
                            bankovnictví
                        </h1>
                        <h2 class="hide_lt-lg">
                            Lepší hypotéka
                            <br />
                            z pohodlí Vašeho domova
                            <br />
                            bez nutnosti osobních schůzek.
                        </h2>
                    </div>
                    <img class="hide_lt-lg" src="../../../../../assets/login.svg" />
                </div>
            </div>
            <div class="right" fxFlex="100" fxLayout="column" fxLayoutAlign="center center">
                <form class="login" (ngSubmit)="submitForm()" [formGroup]="loginForm" novalidate="novalidate">
                    <div (@changeEffectFade.done)="onChangeEffect($event)" [@changeEffectFade]="changeState">
                        @if (loginStep === LoginSteps.EnterEmailOrPhone) {
                            <h3>Přihlášení</h3>
                        }
                        @if (loginStep === LoginSteps.CheckEmail) {
                            <h4>
                                Zkontrolujte
                                <br />
                                svůj e-mail
                            </h4>
                        }
                    </div>
                    <div (@changeEffect.done)="onChangeEffect($event)" [@changeEffect]="changeState">
                        @switch (loginStep) {
                            @case (LoginSteps.EnterEmailOrPhone) {
                                <ng-container [ngTemplateOutlet]="emailOrPhoneTemplate"></ng-container>
                            }
                            @case (LoginSteps.CheckEmail) {
                                <ng-container [ngTemplateOutlet]="checkEmailTemplate"></ng-container>
                            }
                        }
                        <ng-template #emailOrPhoneTemplate>
                            <div class="fx-c fx-g-10">
                                <div class="fx-c">
                                    @if (phoneInputActive) {
                                        <div class="hypo-input-label">Telefonní číslo</div>
                                        <mat-form-field
                                            class="phone-input flex flex-row"
                                            floatLabel="always"
                                            [class.highlight]="phoneHighlight"
                                            ><!-- fxLayout="row" floatLabel="always" -->
                                            <!--mat-label>Telefonní číslo:</mat-label-->
                                            <div class="flex flex-row">
                                                <input
                                                    class="phone"
                                                    matInput="matInput"
                                                    type="text"
                                                    formControlName="phoneNumber"
                                                    [attr.data-testid]="'login-dialog-phone-number'"
                                                    [mask]="
                                                        ['+420', '+421'].includes(
                                                            loginForm.get('phoneCountryCode')?.value?.['code'] ?? ''
                                                        )
                                                            ? '000 000 000'
                                                            : '00009999999'
                                                    "
                                                    inputmode="tel"
                                                    style="order: 2"
                                                    hypo-autofocus="hypo-autofocus" />
                                                <mat-select
                                                    class="phone-conutry-code"
                                                    #phoneCountryCodeSelect
                                                    formControlName="phoneCountryCode"
                                                    style="width: 220px; order: 1; margin-right: 10px"
                                                    [attr.data-testid]="'login-dialog-phone-country-code'">
                                                    <mat-select-trigger class="fx-r fx-pc-c-fs fx-g-5">
                                                        <img
                                                            class="flag"
                                                            src="https://cdn.hyponamiru.cz/assets/icons/flags@2x.png"
                                                            [style]="{
                                                                'object-position':
                                                                    '0 -' + phoneCountryCodeSelect.value.pos + 'px',
                                                            }" />
                                                        <span>{{ phoneCountryCodeSelect.value.abbr }}</span>
                                                        <span>{{ phoneCountryCodeSelect.value.code }}</span>
                                                    </mat-select-trigger>
                                                    @for (code of phoneCountryCodes; track code) {
                                                        <mat-option
                                                            [attr.data-testid]="
                                                                'login-dialog-phone-country-code:' + code
                                                            "
                                                            [value]="code">
                                                            <div class="fx-r fx-pc-c-fs fx-g-5">
                                                                <img
                                                                    class="flag"
                                                                    src="https://cdn.hyponamiru.cz/assets/icons/flags@2x.png"
                                                                    [style]="{
                                                                        'object-position': '0 -' + code.pos + 'px',
                                                                    }" />
                                                                <span>{{ code.abbr }}</span>
                                                                <span>{{ code.code }}</span>
                                                            </div>
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                            </div>
                                        </mat-form-field>
                                        <a
                                            class="link-like"
                                            (click)="phoneInputActive = !phoneInputActive"
                                            [attr.data-testid]="'login-dialog-switch-email'">
                                            Přihlásit emailem
                                        </a>
                                    } @else {
                                        <app-hypo-input
                                            inputmode="email"
                                            label="E-mailová adresa"
                                            patternErrorMessage="Špatný formát emailu (priklad@domena.cz)"
                                            formControlName="email"
                                            [attr.data-testid]="'login-dialog-email'"
                                            [hideOptionalLabel]="true"
                                            [highlight]="emailHighlight"></app-hypo-input>
                                        <a
                                            class="link-like"
                                            (click)="phoneInputActive = !phoneInputActive"
                                            [attr.data-testid]="'login-dialog-switch-phone'">
                                            Přihlásit telefonem
                                        </a>
                                    }
                                    <ng-template #emailInputTemplate>
                                        <app-hypo-input
                                            inputmode="email"
                                            label="E-mailová adresa"
                                            patternErrorMessage="Špatný formát emailu (priklad@domena.cz)"
                                            formControlName="email"
                                            [attr.data-testid]="'login-dialog-email'"
                                            [hideOptionalLabel]="true"
                                            [highlight]="emailHighlight"></app-hypo-input>
                                        <a
                                            class="link-like"
                                            (click)="phoneInputActive = !phoneInputActive"
                                            [attr.data-testid]="'login-dialog-switch-phone'">
                                            Přihlásit telefonem
                                        </a>
                                    </ng-template>
                                </div>
                                <div class="fx-c" style="margin-top: 20px">
                                    <button
                                        class="button orange big login-button-continue"
                                        matRipple="matRipple"
                                        type="submit"
                                        [disabled]="isLogging"
                                        [attr.data-testid]="'login-dialog-button-continue'">
                                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                                            @if (!isLogging) {
                                                <span>Pokračovat</span>
                                                <mat-icon>arrow_forward</mat-icon>
                                            } @else {
                                                <span>Přihlašování</span>
                                                <mat-spinner diameter="24"></mat-spinner>
                                            }
                                            <ng-template #isLoggingTemplate>
                                                <span>Přihlašování</span>
                                                <mat-spinner diameter="24"></mat-spinner>
                                            </ng-template>
                                        </div>
                                    </button>
                                </div>
                                <a
                                    href="https://www.hyponamiru.cz/hypoteky/hypotecni-kalkulacka"
                                    [attr.data-testid]="'login-dialog-new-mortgage'">
                                    Nová kalkulace hypotéky
                                </a>
                            </div>
                        </ng-template>
                        <ng-template #checkEmailTemplate>
                            <div fxLayout="column" fxLayoutGap="20px">
                                <div fxLayout="column">
                                    <p class="magic-login-text text-left">
                                        Právě jsme Vám zaslali magický odkaz na e-mail
                                        <span>
                                            {{ loginForm.get('email').value }} Klikněte na něj pro přihlášení. Pokud vám
                                            nedorazil, zkontrolujte složky Hromadné a Spam.
                                        </span>
                                    </p>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="center center">
                                    <div
                                        class="link login-use-different-email"
                                        (click)="changeStep(LoginSteps.EnterEmailOrPhone)"
                                        fxLayout="row"
                                        fxLayoutAlign="center center"
                                        fxLayoutGap="10px">
                                        @if (!isLogging) {
                                            <span>Použít jiný e-mail</span>
                                            <mat-icon>arrow_back</mat-icon>
                                        }
                                        @if (isLogging) {
                                            <span>Přihlašování</span>
                                            <mat-spinner diameter="24"></mat-spinner>
                                        }
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </form>
                <div class="links">
                    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
                        <div fxFlex="100" fxLayoutAlign="center center" fxLayoutGap="10px">
                            <a
                                class="left-navigation-button vop"
                                href="https://www.hyponamiru.cz/obchodni-podminky/"
                                target="_blank">
                                VOP
                            </a>
                            <a
                                class="left-navigation-button personal-info"
                                href="https://www.hyponamiru.cz/zasady-ochrany-osobnich-udaju/"
                                target="_blank">
                                Osobní údaje
                            </a>
                            <a
                                class="left-navigation-button cookies"
                                href="https://www.hyponamiru.cz/cookies/"
                                target="_blank">
                                Cookies
                            </a>
                        </div>
                        <div class="copyright" fxFlex="100" fxLayoutAlign="center center">
                            &copy; {{ currentYear }} Hypo na míru s.r.o. xxx
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
